import product from '@/api/product'
import Branch from '@/api/branch'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  categories: [],
  uomcategories: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_CATEGORY(state, data) {
    state.categories = data
  },
  SET_UOMC(state, data) {
    state.uomcategories = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return product.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return product.store(data)
  },

  update(context, data) {
    return product.update(data)
  },
  copyPrice(context, data) {
    return product.copyPrice(data)
  },
  destroy(context, id) {
    return product.destroy(id)
  },
  async getBarcode(context, category_id) {
    return await product.getBarcode(category_id)
  },
  async getSaleCode(context, payload) {
    let params = Object.assign(
      {
        uom_cat_id: payload.uom_cat_id,
        product_id: payload.product_id,
        product_barcode: payload.product_barcode
      },
      {}
    )
    return await product.getSaleCode({ params })
  },
  getBranch(context, attributes = {}) {
    return Branch.get({
      params: {
        fields: {
          setup_branch_profiles: 'branch_id,branch_name_en'
        },
        page: -1,
        ...attributes
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await product.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  async dataBeforeCreate(context) {
    if (!context.state.categories.length > 0) {
      let response = await product.getCategory()
      context.commit('SET_CATEGORY', response)
    }
    if (!context.state.uomcategories.length > 0) {
      let response = await product.getUOMC()
      context.commit('SET_UOMC', response)
    }
  }
}
